import {
  Flex,
  Text,
  Switch,
  Select,
  Popover,
  IconButton,
} from "@radix-ui/themes";
import { AvatarIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";
import { useUserProfile } from "../hooks/useUserProfile";

export function UserProfilePopover() {
  const { t } = useTranslation();
  const { profile, updateProfile } = useUserProfile();

  const handleDarkModeChange = async (checked: boolean) => {
    try {
      await updateProfile({ dark_mode: checked });
    } catch (error) {
      console.error("Failed to update dark mode:", error);
    }
  };

  const handleLanguageChange = async (value: string) => {
    try {
      await updateProfile({ lang: value as "en" | "fr" });
    } catch (error) {
      console.error("Failed to update language:", error);
    }
  };

  return (
    <Popover.Root>
      <Popover.Trigger>
        <IconButton
          variant="ghost"
          radius="full"
          title={t("userProfile.title")}
        >
          <AvatarIcon width="18" height="18" />
        </IconButton>
      </Popover.Trigger>
      <Popover.Content width="240px" side="bottom" align="end">
        <Flex direction="column" gap="3">
          <Text size="2" weight="bold">
            {t("userProfile.title")}
          </Text>

          {/* Dark Mode */}
          <Flex align="center" justify="between">
            <Text size="2">{t("userProfile.darkMode")}</Text>
            <Switch
              size="1"
              checked={profile?.dark_mode ?? false}
              onCheckedChange={handleDarkModeChange}
            />
          </Flex>

          {/* Language */}
          <Flex align="center" justify="between">
            <Text size="2">{t("userProfile.lang")}</Text>
            <Select.Root
              value={profile?.lang ?? "en"}
              onValueChange={handleLanguageChange}
            >
              <Select.Trigger variant="soft" />
              <Select.Content>
                <Select.Item value="en">{t("userProfile.en")}</Select.Item>
                <Select.Item value="fr">{t("userProfile.fr")}</Select.Item>
              </Select.Content>
            </Select.Root>
          </Flex>
        </Flex>
      </Popover.Content>
    </Popover.Root>
  );
}
